import { Box, Divider, IconButton, Modal, Typography, styled, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

import { Form } from './Form';

interface Props {
  open: boolean;
  agencyId: string;
  onClose: () => void;
}

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  background: theme.palette.background.paper,
  'box-shadow': 24,
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
}));

export const CreateOrganizationModal = ({ open, onClose, agencyId }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('organizations.create.title')}>
      <StyledBox display="flex" flexDirection="column" gap={theme.spacing(2)}>
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <Typography variant="h6" component="h2">
              {t('organizations.create.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <Form onClose={onClose} agencyId={agencyId} />
      </StyledBox>
    </Modal>
  );
};
